import Joi, { uuidv4 } from '../../helpers/joiCommonSchemas';
import { FieldBooleanSwitch } from './constants';

export const _generateBooleanSwitchErrorResponse = (allowedValues) => {
  const requiredResponse = allowedValues.map((value) => FieldBooleanSwitch.RESPONSE_VALUE_MAP[value]);

  if (allowedValues.length === 1) {
    return `requires the following options to be selected:<ul><li>${requiredResponse}</li></ul>`;
  }
  return 'requires a response';
};

export const booleanSwitchResponseSchema = (allowedValues) =>
  Joi.object()
    .keys({
      allowedValues: Joi.array().items(Joi.boolean().required()).optional(),
      hasError: Joi.boolean().optional(),
      id: Joi.string().required(),
      label: Joi.string().required(),
      prefillField: Joi.boolean().required(),
      required: Joi.boolean().optional(),
      systemTag: Joi.string().optional(),
      type: Joi.string().required(),
      value: Joi.boolean()
        .valid(...allowedValues)
        .required()
        .messages({
          'any.only': _generateBooleanSwitchErrorResponse(allowedValues),
        }),
      visitorTypes: Joi.array().items(uuidv4()).allow(null).required(),
    })
    .options({ convert: false, stripUnknown: true });
